import React from 'react';
import { Button, ButtonProps } from 'pounceV2';
import { useFormikContext } from 'formik';

export interface SubmitButtonPropsV3 extends ButtonProps {
  allowPristineSubmission?: boolean;
  allowInvalidSubmission?: boolean;
  innerRef?: React.RefObject<HTMLButtonElement>;
}

export const SubmitButtonV3: React.FC<SubmitButtonPropsV3> = ({
  allowPristineSubmission,
  allowInvalidSubmission,
  innerRef,
  size,
  ...rest
}) => {
  const { isSubmitting, isValid, dirty, submitForm } = useFormikContext<any>();
  return (
    <Button
      type="submit"
      size={size}
      onClick={e => {
        // We force a submission instead of relying in native HTML (from `type="submit"`), in order
        // to cover cases of a remote form submission
        e.preventDefault();
        submitForm();
      }}
      loading={isSubmitting}
      disabled={
        isSubmitting ||
        (!isValid && !allowInvalidSubmission) ||
        (!dirty && !allowPristineSubmission)
      }
      ref={innerRef}
      {...rest}
    />
  );
};
